<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-shield-alt mr-1"/>
        </template>
        <template v-slot:title>
            {{ __('general.authorization') }}
        </template>
        <template v-slot:description>
            {{ __('integrations.manage_authorizations_for', {for: 'youbuyda'}) }}
        </template>
        <template v-slot:toolbar>
            <slot name="actions"/>
        </template>

        <p>{{ __('general.thing.authorized_success_for', {thing: 'youbuyda', for: integration.name}) }}</p>
        <button class="btn btn-sm btn-outline-warning" @click="reAuthenticateIntegration">
            <i class="fas fa-user-lock"/>
            {{ __('integrations.authorize_again') }}
        </button>
    </Card>
</template>

<script>
import Card from '@components/Cards/Card.vue';

export default {
    components: {Card},
    props: {
        integration: Object,
    },

    methods: {
        reAuthenticateIntegration() {
            this.$inertia.visit(this.$route('integration.enable', [this.integration.code]));
        },
    },
};
</script>
